import { AdminButton } from '@/components/shared/AdminButton'
import { AdminDate } from '@/components/shared/AdminDate'
import { AdminLoading } from '@/components/shared/AdminLoading'
import { AdminTable, type ColumnDef } from '@/components/shared/AdminTable'
import { AdminTooltip } from '@/components/shared/AdminTooltip'
import { useCarriers } from '@/hooks/useCarriers'

import { useSystemNotifications } from './queries'
import type { NotificationFormModel } from './types'

type Props = {
  onEdit: (note: NotificationFormModel) => void
  onRemove: (note: NotificationFormModel) => void
}
export const NotificationList = ({ onEdit, onRemove }: Props) => {
  const { data: items, isLoading } = useSystemNotifications()
  const carriers = [{ name: 'All', id: '' }, ...useCarriers()]
  if (isLoading) {
    return <AdminLoading />
  }

  const columns: ColumnDef<NotificationFormModel>[] = [
    {
      key: 'text',
      render: r => (
        <AdminTooltip label={r.text}>
          <div className="line-clamp-2 overflow-hidden text-ellipsis max-w-[600px]">
            {r.text}
          </div>
        </AdminTooltip>
      ),
    },
    { key: 'type', render: r => r.type },
    {
      key: 'carrier',
      render: r =>
        r.carrierId ? carriers.find(c => c.id === r.carrierId)?.name : 'n/a',
    },
    { key: 'user type', render: r => r?.userType?.join(', ') || 'shipper' },
    {
      key: 'expiration',
      render: r => <AdminDate format="YYYY-MM-DD hh:mm A" val={r.expiration} />,
    },
    {
      key: 'actions',
      render: r => (
        <div className="flex gap-x-2">
          <AdminButton
            className="btn-xs"
            icon="edit"
            onClick={() => onEdit(r)}
          />
          <AdminButton
            className="btn-xs btn-error"
            icon="trash"
            onClick={() => onRemove(r)}
          />
        </div>
      ),
    },
  ]
  return (
    <AdminTable
      data={items}
      rowKey={r => r._id}
      columns={columns}
      emptyContent="No notifications have been created"
    />
  )
}
